import './rgpd';
import './rgpd-list'; 
import './rgpd-edit';